<template>
  <div id="app">
    <Loading v-if="getLoading" />
    <MainLoading v-if="getMainLoading" />
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loading from "@/components/shared/Loading";
import MainLoading from "@/components/shared/MainLoading";
import AuthService from "@/services/authService";

export default {
  name: "App",
  components: { MainLoading, Loading },
  computed: {
    ...mapGetters("common", [
      "getLoading",
      "getMainLoading",
      "getCountries",
    ]),
    ...mapGetters("auth", ["loggedIn"]),
  },

  watch: {
    loggedIn(newValue, oldValue) {
      // Handle auth state changes at app level
      if (oldValue === true && newValue === false) {
        // User was logged in but now logged out
        console.log("User logged out, checking current route");

        // Check if current route requires auth
        if (this.$route.meta?.authRequired) {
          console.log("Redirecting to login from protected route");
          this.$router.push({
            name: "login",
            query: {
              redirect: this.$route.fullPath,
              reason: "session_expired",
            },
          });
        }
      }

      // Start/stop auth checking based on login state
      if (newValue && !AuthService.authCheckInterval) {
        AuthService.startAuthChecking(this.$store);
      } else if (!newValue && AuthService.authCheckInterval) {
        AuthService.stopAuthChecking();
      }
    },
  },

  mounted() {
    this.$store.dispatch("common/getCountries");

    // Start auth checking if user is logged in
    if (this.loggedIn) {
      AuthService.startAuthChecking(this.$store);
    }
  },

  beforeDestroy() {
    // Stop auth checking when app is destroyed
    AuthService.stopAuthChecking();
  },
};
</script>
